import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export enum EDITOR_TYPE {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  EDITOR = 'EDITOR',
  ADI = 'ADI',
  EDITORX = 'EDITORX',
  STUDIO = 'STUDIO',
  EDITOR3 = 'EDITOR3',
  PICASSO = 'PICASSO',
  ODEDITOR = 'ODEDITOR',
  STUDIO_TWO = 'STUDIO_TWO',
}
export interface ISiteItem {
  _id: string;
  name: string;
  url: string;
  thumbnail: string;
  premium: boolean;
  editorType: EDITOR_TYPE;
}

export interface ISiteSelector {
  id: string;
  type: MESSAGES.SITE_SELECTOR;
  nodeId: string;
  pageSize: number;
  rm: boolean;
  items: ISiteItem[];
  role?: string;
}

export const createSiteSelector = (data): ISiteSelector => {
  return {
    id: data.id || uuid(),
    type: MESSAGES.SITE_SELECTOR,
    nodeId: data.nodeId,
    pageSize: data.pageSize,
    rm: Boolean(data.rm),
    items: data.items,
  };
};
